import { AutoAwesome, Comment, Favorite, ThumbDownAlt, ThumbUp } from "@mui/icons-material";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import { Avatar, Box, Button, Stack } from "@mui/material";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";
import { styled } from "@mui/material/styles";
import axios from "axios";
import Cookies from "js-cookie";
import * as React from "react";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { FlexBox } from "./FlexBox";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: "1px solid #E2ECF5",
  borderRadius: "18px !important",
  overflow: "hidden",
  marginBottom: theme.spacing(1.5),
  backgroundColor: "#FFFFFF",
  boxShadow: "0 7px 22px rgba(15,45,75,.055)",
  transition: "box-shadow .18s ease, transform .18s ease, border-color .18s ease",
  "&:hover": {
    boxShadow: "0 12px 30px rgba(15,45,75,.085)",
    borderColor: "#D4E5F3",
  },
  "&:before": { display: "none" },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.85rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: "#FBFDFF",
  minHeight: 70,
  flexDirection: "row-reverse",
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  "& .MuiAccordionSummary-expandIconWrapper": { color: "#7890A5" },
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": { transform: "rotate(90deg)" },
  "& .MuiAccordionSummary-content": { margin: theme.spacing(1, 0) },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid #EDF2F7",
  backgroundColor: "#FFFFFF",
  color: "#334155",
}));

const BidLink = ({ to, id, label = "לצפייה במכרז" }) => (
  <NavLink to={to} style={{ textDecoration: "none" }}>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1.5,
        px: 1.75,
        py: 1.4,
        mb: 1,
        borderRadius: "14px",
        border: "1px solid #E4EDF5",
        backgroundColor: "#F9FCFF",
        transition: "all .16s ease",
        "&:hover": {
          transform: "translateY(-1px)",
          borderColor: "#B9D9F4",
          backgroundColor: "#F1F8FF",
        },
      }}
    >
      <Box sx={{ textAlign: "right" }}>
        <Typography sx={{ fontFamily: "Assistant", fontWeight: 800, color: "#17324D", fontSize: "15px" }}>
          מכרז #{id}
        </Typography>
        <Typography sx={{ fontFamily: "Assistant", color: "#6B7F92", fontSize: "13px" }}>
          {label}
        </Typography>
      </Box>
      <Button
        component="span"
        size="small"
        sx={{
          flexShrink: 0,
          fontFamily: "Assistant",
          fontWeight: 800,
          borderRadius: "10px",
          textTransform: "none",
          color: "#1677C8",
          backgroundColor: "#EAF5FF",
          px: 1.4,
          "&:hover": { backgroundColor: "#DDEFFF" },
        }}
      >
        פתח
      </Button>
    </Box>
  </NavLink>
);

const EmptyState = ({ children }) => (
  <Box sx={{ textAlign: "center", py: 2.5, px: 1, borderRadius: "14px", backgroundColor: "#FAFCFE" }}>
    <Typography sx={{ fontFamily: "Assistant", color: "#718296", fontSize: "14.5px" }}>{children}</Typography>
  </Box>
);

const SectionTitle = ({ icon, title, count }) => (
  <FlexBox sx={{ fontFamily: "Assistant", width: "100%", alignItems: "center", gap: 1.3, marginBottom: 0 }}>
    <Avatar sx={{ width: 40, height: 40, bgcolor: "#EAF5FF", color: "#1677C8" }}>{icon}</Avatar>
    <Box sx={{ textAlign: "right" }}>
      <Typography sx={{ fontFamily: "Assistant", fontWeight: 850, color: "#17324D", fontSize: "15.5px" }}>{title}</Typography>
      <Typography sx={{ fontFamily: "Assistant", color: "#7A8FA2", fontSize: "12.5px" }}>{count} פריטים</Typography>
    </Box>
  </FlexBox>
);

export default function CommentsExpand() {
  const [result, setResult] = useState([]);
  const [comments, setComments] = useState([]);
  const [postedBids, setPostedBids] = useState([]);
  const [biddedBids, setBiddedBids] = useState([]);
  const [expanded, setExpanded] = React.useState("panel1");

  useEffect(() => {
    axios
      .get(`${process.env.React_APP_BACKEND_URL}/api/gettotalbids`, {
        headers: { Authorization: `Bearer ${Cookies.get("token")}` },
      })
      .then((res) => {
        console.log(res);
        setPostedBids(res.data.postedBids);
        setBiddedBids(res.data.biddedBids);
        setComments(res.data.Comments);
        let resul = res.data.Result;
        let secondRes = res.data.SecondResult;
        resul = resul.concat(secondRes);
        resul.sort(function (a, b) {
          return parseInt(b.bidId) - parseInt(a.bidId);
        });
        console.log(resul);
        setResult(resul);
      })
      .catch((err) => console.log(err));
  }, []);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const activeBids = postedBids.filter((e) => new Date().getTime() - e.deadline < 0);
  const closedBids = postedBids.filter((e) => e.deadline - new Date().getTime() < 0);
  const favIds = Cookies.get("favids").split("f").filter((e) => e !== "f" && e !== "no" && e !== "");

  return (
    <Box
      flex={3}
      sx={{
        width: "100%",
        fontFamily: `${process.env.REACT_APP_FONT}`,
        backgroundColor: "#FFFFFF",
        border: "1px solid #E3EDF6",
        borderRadius: "22px",
        boxShadow: "0 16px 42px rgba(15,45,75,.08)",
        p: { xs: 1.5, sm: 2.5, md: 3 },
      }}
    >
      <Stack spacing={0.4} sx={{ mb: 2.4, textAlign: "right" }}>
        <Typography sx={{ fontFamily: "Assistant", fontWeight: 900, color: "#17324D", fontSize: { xs: "21px", md: "24px" } }}>
          המכרזים שלי
        </Typography>
        <Typography sx={{ fontFamily: "Assistant", color: "#718296", fontSize: "14px" }}>
          כל הפעילות שלך בבידאיט, מסודרת לפי סטטוס
        </Typography>
      </Stack>

      <Accordion expanded={expanded === "panel1"} onChange={handleChange("panel1")}>
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <SectionTitle icon={<ThumbUp sx={{ fontSize: 20 }} />} title="מכרזים פעילים" count={activeBids.length} />
        </AccordionSummary>
        <AccordionDetails>
          {activeBids.map((e) => <BidLink key={e.id} to={`/showbid/${e.id}`} id={e.id} label="המכרז פעיל כרגע" />)}
          {activeBids.length === 0 && <EmptyState>אין לך מכרזים פעילים כרגע</EmptyState>}
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded === "panel2"} onChange={handleChange("panel2")}>
        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
          <SectionTitle icon={<Favorite sx={{ fontSize: 20, color: "#D32F2F" }} />} title="מכרזים מועדפים" count={favIds.length} />
        </AccordionSummary>
        <AccordionDetails>
          {favIds.map((e) => <BidLink key={e} to={`/showbid/${e}`} id={e} label="נשמר במועדפים שלך" />)}
          {favIds.length === 0 && <EmptyState>אין לך מכרזים מועדפים</EmptyState>}
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded === "panel3"} onChange={handleChange("panel3")}>
        <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
          <SectionTitle icon={<ThumbDownAlt sx={{ fontSize: 20, color: grey[700] }} />} title="מכרזים סגורים" count={closedBids.length} />
        </AccordionSummary>
        <AccordionDetails>
          {closedBids.map((e) => <BidLink key={e.id} to={`/showbid/${e.id}`} id={e.id} label="המכרז הסתיים" />)}
          {closedBids.length === 0 && <EmptyState>עדיין אין לך מכרזים סגורים</EmptyState>}
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded === "panel4"} onChange={handleChange("panel4")}>
        <AccordionSummary aria-controls="panel4d-content" id="panel4d-header">
          <SectionTitle icon={<AutoAwesome sx={{ fontSize: 20, color: "#E2A600" }} />} title="מכרזים שזכיתי בהם" count={result.length} />
        </AccordionSummary>
        <AccordionDetails>
          {Array.from(result).map((e) => <BidLink key={e.bidId} to={`/showbid/${e.bidId}`} id={e.bidId} label="זכית במכרז הזה" />)}
          {Array.from(result).length === 0 && <EmptyState>לא זכית באף הצעה עד עכשיו</EmptyState>}
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded === "panel5"} onChange={handleChange("panel5")}>
        <AccordionSummary aria-controls="panel5d-content" id="panel5d-header">
          <SectionTitle icon={<Comment sx={{ fontSize: 20 }} />} title="הערות ותגובות" count={comments.length} />
        </AccordionSummary>
        <AccordionDetails>
          {comments.map((e, i) => <BidLink key={`${e.bidId}-${i}`} to={`/showbid/${e.bidId}`} id={e.bidId} label="מכרז שבו השארת תגובה" />)}
          {comments.length === 0 && <EmptyState>לא הגבת על אף מכרז</EmptyState>}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
